export type CreateTempFileBody = {
    contentType: string;
    name: string;
};
export type CreateTempFileResponse = {
    uploadUrl: string;
    tempFileId: string;
};
